module.exports = __webpack_public_path__ + "static/WEDDING E&M-499-60e1d43ac943aa04f33632cb761533d8.jpg";